import React from 'react';

const Directions = (props)=> {
  return (
	<p className="base-copy directions"><b>Let your child respond to this question on their own. If your child needs help reading or understanding the question, you may help, but let your child select the response. For each question, make sure your child considers all four possible answers before choosing the best one for him or her.</b></p>
  );
}

export default Directions;
